import { render, staticRenderFns } from "./EditBrandModal.vue?vue&type=template&id=4fa8d77a&scoped=true"
import script from "./EditBrandModal.vue?vue&type=script&lang=js"
export * from "./EditBrandModal.vue?vue&type=script&lang=js"
import style0 from "./EditBrandModal.vue?vue&type=style&index=0&id=4fa8d77a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa8d77a",
  null
  
)

export default component.exports